import { Component, Input } from '@angular/core';
import { Message } from 'primeng/api';
import { CodigoValidacion, IHallazgoValidacion } from 'src/app/models/notificacion/whatsapp_flujo.model';

/**
 * Etiquetas legibles por código de validación — SOLO para mostrar el
 * `mensaje` que ya viene del backend con más contexto. No agregan ninguna
 * regla nueva: `validarDefinicion` (back) es la única fuente de qué es
 * válido o no (spec: Publish-Time Structural Validation).
 */
const ETIQUETA_CODIGO_VALIDACION: Record<CodigoValidacion, string> = {
    NODO_INICIAL_AUSENTE: 'Falta el nodo inicial',
    NODO_ID_DUPLICADO: 'Id de nodo duplicado',
    NODO_TIPO_NO_SOPORTADO: 'Tipo de nodo no soportado',
    ARISTA_SIN_DESTINO: 'Opción sin destino',
    NODO_INALCANZABLE: 'Nodo inalcanzable',
    CAMINO_SIN_TERMINAL: 'Camino sin final',
    SIN_ARISTA_HANDOFF: 'Falta una derivación a un humano',
    LIMITE_META_EXCEDIDO: 'Límite de WhatsApp excedido',
};

/**
 * Traduce los `hallazgos` que devuelve el backend (`POST .../validar` y el
 * `catch` de `.../publicar`) al formato de `p-messages`. Función pura,
 * separada del componente para poder probarla sin `TestBed`.
 */
export const mapearHallazgosAMensajes = (hallazgos: IHallazgoValidacion[]): Message[] => {
    return (hallazgos || []).map((hallazgo) => {
        const ubicacion = [
            hallazgo.nodoId ? `nodo "${hallazgo.nodoId}"` : null,
            hallazgo.opcionId ? `opción "${hallazgo.opcionId}"` : null,
        ].filter(Boolean).join(', ');

        return {
            severity: 'error',
            summary: ETIQUETA_CODIGO_VALIDACION[hallazgo.codigo] || hallazgo.codigo,
            detail: ubicacion ? `${hallazgo.mensaje} (${ubicacion})` : hallazgo.mensaje,
        } as Message;
    });
};

@Component({
    selector: 'app-flujo-validacion-panel',
    templateUrl: './flujo-validacion-panel.component.html',
})
export class FlujoValidacionPanelComponent {

    /** `null` = todavía no se corrió ninguna validación en esta sesión de edición. */
    @Input() valido: boolean | null = null;
    @Input() hallazgos: IHallazgoValidacion[] = [];
    @Input() validando = false;

    get mensajes(): Message[] {
        return mapearHallazgosAMensajes(this.hallazgos);
    }

    get muestraExito(): boolean {
        return this.valido === true && !this.validando;
    }
}
